import { Component, computed, input } from "@angular/core";
import { KENDO_SVGICON } from "@progress/kendo-angular-icons";
import { infoCircleIcon, warningTriangleIcon } from "@progress/kendo-svg-icons";

/** A short message under a field: an information with the info icon, or a warning with the warning one. */
@Component({
    selector: "app-field-message",
    imports: [KENDO_SVGICON],
    template: `
        <kendo-svgicon [icon]="icon()"></kendo-svgicon>
        <span><ng-content></ng-content></span>
    `,
    styleUrl: "./field-message.component.scss",
    host: { "[class.warning]": "kind() === 'warning'", "[class.info]": "kind() === 'info'" },
})
export class FieldMessageComponent {
    readonly kind = input<"info" | "warning">("info");

    readonly icon = computed(() => (this.kind() === "warning" ? warningTriangleIcon : infoCircleIcon));
}
